import { graphqlClient } from "../../../client";
import mutationDocument from "./updateResellerPreference.graphql";
import type {
  InputUpdateResellerPreferenceType,
  Mutations,
  MutationsUpdateResellerPreferenceArgs,
} from "@/core/api/graphql/types";

export async function updateResellerPreference(
  resellerPreferenceInput: InputUpdateResellerPreferenceType,
): Promise<boolean | undefined> {
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "updateResellerPreference">>,
    MutationsUpdateResellerPreferenceArgs
  >({
    mutation: mutationDocument,
    variables: { command: resellerPreferenceInput },
  });

  return data!.updateResellerPreference;
}
